import {BackendConditionLink} from '@em/shared/mapping-engine/domain-models';

type avaialbe_backend_operators = NonNullable<BackendConditionLink>['operator'];

export const AvailableLogicalOperators: avaialbe_backend_operators[] = [
  'or',
  'and',
];
